export default "__VITE_ASSET__CSXtcaYy__"